'use es6';

import { push, replace } from 'DesignData/actions/History';
import { CODE_EDITOR_TOGGLE_COMPILED_SPLIT_SCREEN, FINDER_THEMES_SET_ACTIVE_THEME_FOLDER_ID, FINDER_FILE_SHOW_DEPENDENTS, FINDER_FILE_HIDE_DEPENDENTS, FINDER_FILE_SHOW_REVISIONS, FINDER_FILE_HIDE_REVISIONS, FINDER_FILE_VIEW_LAYOUT_SOURCE, TEMPLATE_REVISION_FETCH, TEMPLATE_BUFFER_FETCH, TEMPLATE_BUFFER_FETCH_BY_PATH, UNIFIED_LAYOUT_FETCH, LAYOUT_REVISION_FETCH, GLOBAL_WIDGET_FETCH, GLOBAL_WIDGET_RENAME, CUSTOM_WIDGET_BUFFER_FETCH, CUSTOM_WIDGET_BUFFER_FETCH_BY_PATH, CUSTOM_WIDGET_REVISION_FETCH, RAW_ASSET_BUFFER_FETCH, RAW_ASSET_BUFFER_FETCH_BY_PATH } from 'DesignData/actions/ActionTypes';
import { fetchDefault } from 'DesignData/actions/finder/FileMapper';
import { createPath, createDependentsPath, createRevisionPath, create404Path, createLayoutSourcePath } from 'DesignData/helpers/routingHelper';
import { QUERY_STRING_THEME_FOLDER, QUERY_STRING_SHOW_COMPILED_HUBL } from 'DesignData/constants/Routing';
import { NOT_FOUND } from 'DesignData/enums/HttpStatusCodes';
import { getFile, getActiveThemeFolderId, getIsHubspotFolder } from 'DesignData/selectors/finder';
import { getTabsById, getActiveTabId } from 'DesignData/selectors/tabs';
import { getPathname, getLocation } from 'DesignData/lib/routing';
import { getThemeFolderIdFromUrlSearchString } from 'DesignData/lib/themes/themes';
import { updateTab } from 'DesignData/actions/Tabs';
export default (({
  dispatch,
  getState
}) => next => action => {
  const result = next(action);
  const state = getState();
  const currentPathname = getPathname();
  let pathname;

  switch (result.type) {
    case FINDER_THEMES_SET_ACTIVE_THEME_FOLDER_ID:
      {
        const loc = getLocation(state);
        const tfid = getThemeFolderIdFromUrlSearchString(loc.search);

        if (getIsHubspotFolder(state, {
          folderId: tfid
        })) {
          dispatch(fetchDefault());
        }

        const activeThemeFolderId = getActiveThemeFolderId(state); // Use coercion comparison here b/c values may be string/number/null/undef
        // eslint-disable-next-line eqeqeq

        if (tfid == activeThemeFolderId) {
          break;
        }

        const actionCreator = result.type === FINDER_THEMES_SET_ACTIVE_THEME_FOLDER_ID ? // Add/remove folder search param when set.
        push : // Keep folder search param if theme view is already active.
        // It can be removed via the many push navigations in the IDE code.
        replace;
        const search = activeThemeFolderId ? `?${QUERY_STRING_THEME_FOLDER}=${activeThemeFolderId}` : undefined;
        dispatch(actionCreator(Object.assign({}, loc, {
          search
        })));
        break;
      }

    case CODE_EDITOR_TOGGLE_COMPILED_SPLIT_SCREEN:
      {
        const {
          data: {
            isOverriden
          }
        } = result;
        const loc = window.location;
        const activeTabId = getActiveTabId(state);

        if (isOverriden) {
          const activeTab = getTabsById(state)[activeTabId]; // Tab's override value is set to false after user toggles 'show output' off

          dispatch(updateTab(activeTab, {
            editorOptions: {
              showCompiledOutput: false
            }
          })); // Query param is cleared from the URL

          dispatch(replace(Object.assign({}, loc, {
            query: Object.assign({}, loc.query, {
              [QUERY_STRING_SHOW_COMPILED_HUBL]: undefined
            })
          })));
        }

        break;
      }

    case FINDER_FILE_SHOW_DEPENDENTS:
      {
        const {
          fileId
        } = result;
        const file = getFile(state, {
          fileId
        });
        pathname = createDependentsPath(file.designAssetType, fileId);
        break;
      }

    case FINDER_FILE_SHOW_REVISIONS:
      {
        const {
          fileId
        } = result;
        const file = getFile(state, {
          fileId
        });
        pathname = createRevisionPath(file.designAssetType, fileId);
        break;
      }

    case FINDER_FILE_HIDE_DEPENDENTS:
    case FINDER_FILE_HIDE_REVISIONS:
      {
        const {
          fileId
        } = result;
        const file = getFile(state, {
          fileId
        });
        pathname = createPath(file.designAssetType, fileId);
        break;
      }

    case TEMPLATE_REVISION_FETCH:
    case TEMPLATE_BUFFER_FETCH:
    case TEMPLATE_BUFFER_FETCH_BY_PATH:
    case UNIFIED_LAYOUT_FETCH:
    case LAYOUT_REVISION_FETCH:
    case GLOBAL_WIDGET_FETCH:
    case GLOBAL_WIDGET_RENAME:
    case RAW_ASSET_BUFFER_FETCH:
    case RAW_ASSET_BUFFER_FETCH_BY_PATH:
    case CUSTOM_WIDGET_BUFFER_FETCH:
    case CUSTOM_WIDGET_BUFFER_FETCH_BY_PATH:
    case CUSTOM_WIDGET_REVISION_FETCH:
      {
        const {
          error
        } = result;

        if (error && error.status === NOT_FOUND) {
          pathname = create404Path(result.type);
        }

        break;
      }

    case FINDER_FILE_VIEW_LAYOUT_SOURCE:
      {
        const {
          layoutId
        } = result;
        pathname = createLayoutSourcePath(layoutId);
        break;
      }

    default:
      break;
  }

  if (pathname && pathname !== currentPathname) {
    dispatch(push({
      pathname
    }));
  }

  return result;
});